<template>
	<div>
		<Loader v-if="loading" />
		<div v-else>


			<SelectBox>
                    <div slot="top">
                        <!-- Bank logo skal hentes her -->
                        <img v-if="bankLogo" :src="bankLogo">
                    </div>
                    <div slot="content">
                        <!-- Step 3 - Vælg bank type -->
                        <!-- <div class="radio-list">
                            <label for="choice1" class="item">
                                <input type="radio" name="choice1" id="choice1">
                                <div class="radio"><div class="dot"></div></div>
                                <p>{{ bankName }}</p>
                            </label>
                        </div> -->
                        <!-- Step 4 - Vælg lønkonto -->
                        <div class="select-container">
                            <select v-model="viewAccountId" v-on:change="emit">
                                <option value="">{{ $t('nordicapi.choose-account.label') }}</option>
                                <option v-for="account in accounts" :value="account.id">
                                	{{ account.name }} ({{ account.number.bbanParsed.accountNumber }})
                                </option>
                            </select>
                            <span class="icon">
                                <SvgIcon icon="sort-icon" />
                            </span>
                        </div>
                        <!-- Step 5 - Mens at info bliver hentet -->
                        <!-- <div class="content--waiting">
                            <Loader />
                            <p>{{$t('income.waiting.text')}}</p>
                            <p class="bold">{{$t('income.waiting.bold')}}</p>
                        </div> -->
                    </div>
                </SelectBox>

                <!-- Step 6 - vælg lønoverførsel -->
                <div v-show="viewAccountId">
	                <p class="text-label">{{$t('income.choose-income.label')}}</p>
	                <div class="checkboxes--container">
	                    <!-- liste over mulige lønoverførsler -->
	                    <label class="item"  v-for="statement in statements[viewAccountId]">
	                        <input v-on:change="fireChange()" type="checkbox" v-model="statement.selected" />
	                        <div class="checkbox">
	                            <SvgIcon icon="white-checkmark" />
	                        </div>
	                        <div class="content">
	                            <p>{{ statement.originalText }}</p>
	                            <p class="date">{{ dateFormat(statement.date) }}</p>
	                        </div>
	                        <p class="price">{{ statement.amount | toCurrency }} kr.</p>
	                    </label>
	                </div>
	            </div>



			<div v-if="false" v-for="account in accounts">
				<div>
					{{ account.bankName }}
					<img :src="account.bankLogo" />
					<br />
					<strong>{{account.name}} - {{ account.number.bbanParsed.accountNumber }}</strong>
					<br />
					{{ account.currency }} {{ account.bookedBalance }}
				</div>
				<div>
					<div v-if="!statementsLoaded[account.id]">{{ $t('nordicapi.loading-statements.label') }}</div>
					<table v-else>
						<tbody>
							<tr v-for="statement in statements[account.id]">
								<td>
									<label class="custom-checkbox">
	                                    <input v-on:change="fireChange()" type="checkbox" v-model="statement.selected">
	                                    <span class="checkbox">
	                                        <SvgIcon icon="checkmark-input" />
	                                    </span>
	                                </label>
								</td>
								<td>{{ statement.amount | toCurrency }} kr.</td>
								<td>{{ dateFormat(statement.date) }}</td>
								<td>{{ statement.originalText }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { mapGetters } from 'vuex';

    import Loader from '../../components/Loader.vue';
    import SelectBox from '../../components/SelectBox.vue';
    import SvgIcon from '../../components/Svg.vue';



    Vue.filter('formatDate', function(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY')
        }
    });

	export default {
		data: () => ({
			accounts: {},
			loading: true,
			statements: {},
			statementsLoaded: {},
			viewAccountId: ''
		}),
		components: {
			Loader,
			SelectBox,
			SvgIcon
		},
		computed: {
			...mapGetters([
				'getNordicApiToken',
				'getToken'
			]),
			bankName() {
				var bank = this.getBank();
				return bank ? bank.bankName : '';
			},
			bankLogo() {
				var bank = this.getBank();
				return bank ? bank.bankLogo : '';
			}
		},
		methods: {
			emit() {
				this.$emit('viewaccountid', this.viewAccountId);
			},
			getBank() {
				for (var i in this.accounts) {
					return this.accounts[i];
				}
				return false;
			},
			fireChange() {
				this.$root.$emit('statement-changed', this.getAmount());
			},
			getAmount() {
				var months = [];
				var amount = 0;
				for (var accountId in this.statements) {
					for (var id in this.statements[accountId]) {
						var transaction = this.statements[accountId][id];
						if (transaction.selected) {
							amount += transaction.amount;
							let parseMonth = transaction.date.substr(5, 2);
							if (months.indexOf(parseMonth) == -1) {
								months.push(parseMonth);
							}
						}
					}
				}
				var differentMonths = months.length;
				return amount && differentMonths ? Math.round(amount / differentMonths) : 0;
			},
			load() {
				if (this.getNordicApiToken) {
					axios({
	                    method: 'POST',
	                    url: window.config.apiUrl + 'api/nordicapi/accounts',
						cancelToken: window.AuthorizationCancelSource.token,
	                    data: {
	                        token: this.getNordicApiToken
	                    }
	                }).then(response => {
	                	this.accounts = response.data.accounts;
	                	for (var i in this.accounts) {
	                		var id = this.accounts[i].id;
	                		this.statements[id] = [2,3];
	                		Vue.set(this.statementsLoaded, id, false);
	                	}
	                	this.loading = false;
	                	this.loadNextStatements();
	                });
	               }
			},
			loadNextStatements() {
				for (var i in this.statementsLoaded) {
					if (!this.statementsLoaded[i]) {
						var accountId = i;
						axios({
		                    method: 'POST',
		                    url: window.config.apiUrl + 'api/nordicapi/statements',
							cancelToken: window.AuthorizationCancelSource.token,
		                    data: {
		                        id: accountId,
		                        token: this.getNordicApiToken
		                    }
		                }).then(response => {
                			Vue.set(this.statementsLoaded, accountId, true);
                			Vue.set(this.statements, accountId, response.data);
		                	this.statements[accountId] = response.data;
		                	this.loadNextStatements();
		                });
						break;
					}
				}
				this.updateAutoSelections();
			},
			updateAutoSelections() {
				for (var accountId in this.statements) {
					for (var id in this.statements[accountId]) {
						var transaction = this.statements[accountId][id];
						if (this.textIsPaycheck(transaction.originalText)) {
							Vue.set(this.statements[accountId][id], 'selected', true);
						}
					}
				}
				this.fireChange();
			},
			textIsPaycheck(text) {
				if (text.toLowerCase().indexOf('lønoverførsel') >= 0) {
					return true;
				}
				return false;
			},
			dateFormat(date) {
                return date ? moment(String(date)).format('DD-MM-YYYY') : '';
            }
		},
		created() {
			this.load();
		}
	}
</script>
